exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadbtn {\r\n    color: #0069bd;\r\n    border-color: #0069bd;\r\n    margin: 10px 0px;\r\n    padding: 5px 10px;\r\n}\r\n\r\n.fileContainer {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    -ms-flex-pack: justify;\r\n        justify-content: space-between;\r\n    background-color: #f1f1f1;\r\n    border: 1px solid black;\r\n}\r\n\r\n.filename {\r\n    margin: 0px;\r\n    display:inline-block\r\n}\r\n\r\n.last-btn {\r\n    margin-right: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/app/programs/import-tool/import-tool.component.css
// module id = ../../../../../src/app/programs/import-tool/import-tool.component.css
// module chunks = main